import Accordion from 'accordion-js';

(() => {
	document.querySelectorAll('.accordion-container').forEach(el => {
		let { showmultiple } = el.dataset;
		showmultiple = showmultiple === 'true';
		const options = {
			showMultiple: showmultiple,
		};
		const accordion = new Accordion(el, options);
	});
})();
